export interface TelehealthPrerequisitesFormValues {
  looksAtScreenOnName: string;
  comesToWorkArea: string;
  respondsToMasteredInstructions: string;
  identifiesItemsOnScreen: string;
  respondsToPraise: string;
  remainedSeatedWithoutSupportMinutes: string;
  remainedSeatedWithoutSupportTotal: string;
  remainedSeatedWithoutSupportNA: boolean | null;
  remainedSeatedWithSupportMinutes: string;
  remainedSeatedWithSupportTotal: string;
  remainedSeatedWithSupportNA: boolean | null;
  attendedNoSupportMinutes: string;
  attendedNoSupportTotal: string;
  attendedNoSupportNA: boolean | null;
  attendedWithSupportMinutes: string;
  attendedWithSupportTotal: string;
  attendedWithSupportNA: boolean | null;
  individualizedFactors: string;
  participationStrategies: string;
}

export type TelehealthNAKey =
  | "remainedSeatedWithoutSupportNA"
  | "remainedSeatedWithSupportNA"
  | "attendedNoSupportNA"
  | "attendedWithSupportNA";

export type TelehealthStringKey = Exclude<
  keyof TelehealthPrerequisitesFormValues,
  TelehealthNAKey
>;

export const YES_NO_SOMETIMES_OPTIONS = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
  { value: "SOMETIMES", label: "Sometimes" },
];

export const DROPDOWN_FIELDS: {
  label: string;
  key: TelehealthStringKey;
}[] = [
  { label: "Client looks at the screen upon hearing name via video?", key: "looksAtScreenOnName" },
  {
    label: "Client comes to the work area upon request from the practitioner via video?",
    key: "comesToWorkArea",
  },
  {
    label: "Client responds to the previously mastered instructions delivered via video?",
    key: "respondsToMasteredInstructions",
  },
  {
    label: "Client identifies items on the screen receptively and expressively",
    key: "identifiesItemsOnScreen",
  },
  { label: "Client responds to social praise via video?", key: "respondsToPraise" },
];

export interface MinutePairConfig {
  label: string;
  minutesKey: TelehealthStringKey;
  totalKey: TelehealthStringKey;
  naKey: TelehealthNAKey;
  minutesHelper: string;
  totalHelper: string;
}

export const MINUTE_PAIR_FIELDS: MinutePairConfig[] = [
  {
    label: "Client remained seated during video instruction (without in-person support)",
    minutesKey: "remainedSeatedWithoutSupportMinutes",
    totalKey: "remainedSeatedWithoutSupportTotal",
    naKey: "remainedSeatedWithoutSupportNA",
    minutesHelper: "Minutes without in-person support",
    totalHelper: "Total minutes observed",
  },
  {
    label: "Client remained seated during video instruction (with in-person support)",
    minutesKey: "remainedSeatedWithSupportMinutes",
    totalKey: "remainedSeatedWithSupportTotal",
    naKey: "remainedSeatedWithSupportNA",
    minutesHelper: "Minutes with in-person support",
    totalHelper: "Total minutes observed",
  },
  {
    label:
      "Client attended to screen without engaging in problem behavior (without in-person support)",
    minutesKey: "attendedNoSupportMinutes",
    totalKey: "attendedNoSupportTotal",
    naKey: "attendedNoSupportNA",
    minutesHelper: "Minutes without in-person support",
    totalHelper: "Total minutes observed",
  },
  {
    label:
      "Client attended to screen without engaging in problem behavior (with in-person support)",
    minutesKey: "attendedWithSupportMinutes",
    totalKey: "attendedWithSupportTotal",
    naKey: "attendedWithSupportNA",
    minutesHelper: "Minutes with in-person support",
    totalHelper: "Total minutes observed",
  },
];

export const TEXT_AREA_FIELDS: {
  label: string;
  key: TelehealthStringKey;
  placeholder: string;
}[] = [
  {
    label: "Individualized factors for why telehealth is an appropriate fit for this client",
    key: "individualizedFactors",
    placeholder:
      "Briefly describe why telehealth is a good fit for this client, including the client skills that support virtual treatment and the caregiver's ability and commitment to actively participate in care.",
  },
  {
    label: "What strategies will you use to support participation in telehealth sessions?",
    key: "participationStrategies",
    placeholder: "",
  },
];
